import _v from './vars';
import _u from './util';

let likeClickPending = false;
const likeApiBaseUri = '//www.' + _u.getDomain() + 'medscape.com/api/v1/contentfeedback/article_like';
function likeHandler(e) {
	let element = this;
	e.preventDefault();
	e.stopPropagation();
	
	let parentCard = _u.getClosest(element, '.pers-feed-item, .pers-article-item, .cme-card-container');	
	let uriNoProto = parentCard.getAttribute('data-uri').replace(/^((https?:)?\/\/)/, '').split('?')[0];
	let isAlpha = /\/[^/]+[a-z][^/]+$/.test(uriNoProto);
	if(!isAlpha) {
		uriNoProto = uriNoProto.replace(/\/s\//, '/');
	}		
	if (!likeClickPending) {
		likeClickPending = true;
		
		let data = {
			like_requests : {
				hostName: uriNoProto.split('/')[0],
				contentUri: '/' + uriNoProto.split(/\/(.+)/)[1]
			}
		}
		
		let headerandDataObject = {
				method: 'POST',
				mode: 'cors',
				cache: 'no-cache',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json; charset=utf-8'
				},
				body: JSON.stringify(data)
			};
		_u.apiPost(likeApiBaseUri + '/handle_on_like', headerandDataObject).then(data => {	
			
			let likeText = 'Like';
			if (data.likeCount > 0) {
				if (data.likeCount > 1) {
					likeText = 'Likes';
				}
				element.innerHTML = '<div class="pers-like-text"><span class="pers-like-count">' + data.likeCount + '</span> ' + likeText + '</div>';
			} else {
				element.innerHTML = '<div class="pers-like-text"><span class="pers-like-count"></span> ' + likeText + '</div>';
			}
				
			if (data.interactionType == 1) {
				element.classList.add('like-anim');
				element.onclick = function() { try { wmdPageLink('fy-articlelike_remove', this) } catch(e) {console.log(e)} };
			} else {
				element.classList.remove('liked','like-anim');
				element.onclick = function() { try { wmdPageLink('fy-articlelike_add', this) } catch(e) {console.log(e)} };
			}

			likeClickPending = false;
				
		}).catch(error => {
			console.log(error);
			likeClickPending = false;
		});
	}
}

function fetchLikes() {

    let data = {
        "like_requests": [],
    };
	
	document.querySelectorAll('.pers-like').forEach(element => {
		let parentCard = _u.getClosest(element, '.pers-feed-item, .pers-article-item, .cme-card-container');
			if(parentCard !== null) {
			let uriNoProto = parentCard.getAttribute('data-uri').replace(/^((https?:)?\/\/)/, '').split('?')[0];
			let isAlpha = /\/[^/]+[a-z][^/]+$/.test(uriNoProto);
			if(!isAlpha) {
				uriNoProto = uriNoProto.replace(/\/s\//, '/');
			}		
			if (uriNoProto != '') {
				let reqObj = {
					hostName: uriNoProto.split('/')[0],
					contentUri: '/' + uriNoProto.split(/\/(.+)/)[1]
				};
				data['like_requests'].push(reqObj);
			}
		}
	});

    let headerandDataObject = {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(data)
    };
		
    _u.apiPost(likeApiBaseUri + '/get_like_data', headerandDataObject).then(data => {
        if (typeof data != 'undefined' && data.length != 0) {
			_u.qS('.pers-body').classList.add('show-likes'); // only show Likes if data coming back from API
            data.forEach(d => {
                let element = document.querySelector('*[data-uri*="https://' + d.hostName + d.contentUri + '"] .pers-like');
					if (element != null) {
						element.onclick = function() { try { wmdPageLink('fy-articlelike_add', this) } catch(e) {console.log(e)} };

						if (d.interactionType == 1) {
							element.classList.add('liked');
							element.onclick = function() { try { wmdPageLink('fy-articlelike_remove', this) } catch(e) {console.log(e)} };
						}

						if (d.likeCount > 0) {
							let likeText = 'Likes';
							if (d.likeCount == 1) {
								likeText = 'Like';
							}
							element.innerHTML = '<div class="pers-like-text"><span class="pers-like-count">' + d.likeCount + '</span> ' + likeText + '</div>'
						}

						element.addEventListener('click', likeHandler);	
						element.addEventListener('click', likeHandler);
					}
            });
        }
    }).catch(error => {
        console.log(error);
    });
}

if (typeof window.hideLikes == 'undefined' || !window.hideLikes) {
	// Preload Like animation frames
	_u.preLoadImg(['/pi/features/mymedscape/icons/like-off.svg', '/pi/features/mymedscape/icons/like-hover.svg', '/pi/features/mymedscape/icons/like-on.svg', '/pi/features/mymedscape/icons/like-anim-1@2x.gif', '/pi/features/mymedscape/icons/like-anim-2@2x.gif', '/pi/features/mymedscape/icons/like-anim-3@2x.gif', '/pi/features/mymedscape/icons/like-anim-4@2x.gif', '/pi/features/mymedscape/icons/like-anim-5@2x.gif', '/pi/features/mymedscape/icons/like-anim-6@2x.gif', '/pi/features/mymedscape/icons/like-anim-7@2x.gif', '/pi/features/mymedscape/icons/like-anim-8@2x.gif', '/pi/features/mymedscape/icons/like-anim-9@2x.gif', '/pi/features/mymedscape/icons/like-anim-10@2x.gif', '/pi/features/mymedscape/icons/like-anim-11@2x.gif', '/pi/features/mymedscape/icons/like-anim-12@2x.gif', '/pi/features/mymedscape/icons/like-anim-13@2x.gif', '/pi/features/mymedscape/icons/like-anim-14@2x.gif']);

	// Hack for choppy animation on first run - run it once in a non-visible container, must be run after rest of page loads, or else browser still catching up and doesn't animate....
	document.addEventListener('feedAndTopLoaded', function() {
		setTimeout(function() {
			var tempContain = document.createElement('div');
			tempContain.setAttribute('class','temp-contain');
			tempContain.setAttribute('style','position: absolute; left: -10000px; top: -10000px;');
			tempContain.innerHTML = '<div class="pers-like"></div>';
			document.body.appendChild(tempContain);
			document.querySelector('.temp-contain .pers-like').classList.add('like-anim');
			setTimeout(function() { document.body.removeChild(tempContain); }, 1000);
		}, 1000);
	});
	
	document.addEventListener(_v.initialLoadEvent, function() {
		fetchLikes();
		document.addEventListener('feedLoaded', fetchLikes);
	});
	
}